<template>
    <main class="col-md-9 ms-sm-auto col-lg-10 px-md-4">
        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <div class="h4">个人信息</div>
            <div class="btn-toolbar mb-2 mb-md-0">
                <div class="btn-group me-2">
                    <button type="button" class="btn btn-sm btn-outline-secondary" style="font-size: 13px;" @click="open">修改个人信息</button>

                    <el-dialog title="用户信息" :visible.sync="dialogFormVisible">
                        <el-form>
                            <el-form-item label="名称" :label-width="formLabelWidth">
                                <el-input v-model="name" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-form>

                        <el-form>
                            <el-form-item label="上传头像" :label-width="formLabelWidth">
                                <!-- <el-input v-model="photo" autocomplete="off"></el-input> -->
                                <input type="file" @change="handleFileUpload" accept="image/*" />
                                
                                <p v-if="imageType">图片类型: {{ imageType }}</p>
                            </el-form-item>
                        </el-form>

                        <el-form>
                            <el-form-item label="头像预览" :label-width="formLabelWidth">
                                <div>
                                    <img v-if="imageUrl" :src="imageUrl" alt="Uploaded Image" width="100" height="100" style="border-radius: 50%;"/>
                                </div>
                            </el-form-item>
                        </el-form>
                        
                        <el-form>
                            <el-form-item label="个人简介" :label-width="formLabelWidth">
                                <el-input type="textarea" v-model="about"></el-input>
                            </el-form-item>
                        </el-form>

                        <div slot="footer" class="dialog-footer">
                            <el-button @click="cancel">取 消</el-button>
                            <el-button type="primary" @click="accept">确 定</el-button>
                        </div>
                    </el-dialog>
                </div>
            </div>
        </div>
    <!-- 1111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111 -->
        <el-descriptions title="用户信息" direction="vertical" :column="4" border>
            <el-descriptions-item label="昵称"> {{ this.$store.state.me.name }} </el-descriptions-item>
            <el-descriptions-item label="用户名 / 账号"> {{ this.$store.state.me.username }} </el-descriptions-item>
            <el-descriptions-item label="照片链接" :span="2"> {{ this.$store.state.me.photo }} </el-descriptions-item>
            <el-descriptions-item label="rating"> {{ this.$store.state.me.rating }} </el-descriptions-item>
            <el-descriptions-item label="个人简介"> {{ this.$store.state.me.about }} </el-descriptions-item>
        </el-descriptions>
        <el-descriptions  direction="vertical" :column="4" border>
            <el-descriptions-item label="头像照片"> 
                <img :src="this.$store.state.me.photo" alt="" width="200">
            </el-descriptions-item>
        </el-descriptions>
    <!-- 1111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111 -->
<!-- 
        <canvas class="my-4 w-100" id="myChart" width="900" height="380">
            这里是图表
        </canvas>
    你好
        <h2>Section title</h2>
        <div class="table-responsive">
            <table class="table table-striped table-sm">
            <thead>
                <tr>
                <th scope="col">#</th>
                <th scope="col">Header</th>
                <th scope="col">Header</th>
                <th scope="col">Header</th>
                <th scope="col">Header</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                <td>1,001</td>
                <td>random</td>
                <td>data</td>
                <td>placeholder</td>
                <td>text</td>
                </tr>
                <tr>
                <td>1,002</td>
                <td>placeholder</td>
                <td>irrelevant</td>
                <td>visual</td>
                <td>layout</td>
                </tr>
                <tr>
                <td>1,003</td>
                <td>data</td>
                <td>rich</td>
                <td>dashboard</td>
                <td>tabular</td>
                </tr>
                <tr>
                <td>1,003</td>
                <td>information</td>
                <td>placeholder</td>
                <td>illustrative</td>
                <td>data</td>
                </tr>
                <tr>
                <td>1,004</td>
                <td>text</td>
                <td>random</td>
                <td>layout</td>
                <td>dashboard</td>
                </tr>
                <tr>
                <td>1,005</td>
                <td>dashboard</td>
                <td>irrelevant</td>
                <td>text</td>
                <td>placeholder</td>
                </tr>
                <tr>
                <td>1,006</td>
                <td>dashboard</td>
                <td>illustrative</td>
                <td>rich</td>
                <td>data</td>
                </tr>
                <tr>
                <td>1,007</td>
                <td>placeholder</td>
                <td>tabular</td>
                <td>information</td>
                <td>irrelevant</td>
                </tr>
                <tr>
                <td>1,008</td>
                <td>random</td>
                <td>data</td>
                <td>placeholder</td>
                <td>text</td>
                </tr>
                <tr>
                <td>1,009</td>
                <td>placeholder</td>
                <td>irrelevant</td>
                <td>visual</td>
                <td>layout</td>
                </tr>
                <tr>
                <td>1,010</td>
                <td>data</td>
                <td>rich</td>
                <td>dashboard</td>
                <td>tabular</td>
                </tr>
                <tr>
                <td>1,011</td>
                <td>information</td>
                <td>placeholder</td>
                <td>illustrative</td>
                <td>data</td>
                </tr>
                <tr>
                <td>1,012</td>
                <td>text</td>
                <td>placeholder</td>
                <td>layout</td>
                <td>dashboard</td>
                </tr>
                <tr>
                <td>1,013</td>
                <td>dashboard</td>
                <td>irrelevant</td>
                <td>text</td>
                <td>visual</td>
                </tr>
                <tr>
                <td>1,014</td>
                <td>dashboard</td>
                <td>illustrative</td>
                <td>rich</td>
                <td>data</td>
                </tr>
                <tr>
                <td>1,015</td>
                <td>random</td>
                <td>tabular</td>
                <td>information</td>
                <td>text</td>
                </tr>
            </tbody>
            </table>
        
        </div> -->
    </main>
</template>

<script>
    import $ from 'jquery'

    export default {
        name:'Info',
        data() {
            return {
                name:'',
                about:'',
                photo:'',
                dialogFormVisible: false,
                formLabelWidth: '120px',

                imageName:'',
                image:'',

                imageUrl: '',
                imageType: '',
                fileToUpload: null,
                extension:'',
            }
        },
        methods: {
            handleFileUpload(event) { // 看图片类型
                const file = event.target.files[0];
                
                const reader = new FileReader();

                reader.onload = (e) => {
                    this.imageUrl = e.target.result; // 设置预览图像的URL
                    // console.log("url == >", this.imageUrl)
                    this.fileToUpload = file; // 将文件保存在组件数据中
                    this.photo = file.name
                    // 获取文件的扩展名
                    const extension = file.name.split('.').pop().toLowerCase();
                    // 获取文件的MIME类型
                    const fileType = file.type;
                    // console.log(file)
                    console.log("图片类型", extension)
                    this.extension = extension
                    this.image = "https://app6132.acapp.acwing.com.cn/static/image/" +  this.imageName + "." + extension
                    // console.log("type", fileType)
                    // 设置图片类型信息
                    this.imageType = fileType;
                };

                if (file === null || file === undefined) {
                    this.photo = ""
                    this.imageUrl = ""
                    this.imageType = ""
                    this.fileToUpload = null
                    console.log("没有图片捏")
                    return
                }
                // 读取文件为DataURL
                reader.readAsDataURL(file);
            },
            uploadFile() { // 传给后端 使得图片有url
                if (!this.fileToUpload) {
                    console.error('没有选择文件 或者 没有输入图片名称');
                    return;
                }
                const vue = this
                // 创建一个FormData对象，将文件附加到其中
                const formData = new FormData();
                formData.append('image', this.fileToUpload);
                formData.append('userid', this.$store.state.me.id)
                // 使用$.ajax发送文件到后端（假设上传的URL是/upload）
                $.ajax({
                    url: 'https://app6132.acapp.acwing.com.cn/jdg/upload/head/',
                    method: 'POST',
                    data: formData,
                    processData: false,
                    contentType: false,
                    success: (response) => {
                        console.log('文件上传成功');
                        
                        const message = vue.$message

                        const name = vue.name.trim()
                        const about = vue.about.trim()
                        const photo = vue.photo.trim()

                        const store = vue.$store

                        $.ajax({
                            url:'https://app6132.acapp.acwing.com.cn/api/user/account/update/',
                            type:'post',
                            data: {
                                name:name,
                                about:about,
                                photo:'https://app6132.acapp.acwing.com.cn/static/head/' + store.state.me.id + "." + vue.extension,
                            },
                            headers: {
                                Authorization: "Bearer " + store.state.me.token
                            },
                            success(resp) {
                                if (resp.error_message === "success") {
                                    console.log("修改成功了")
                                    // 直接获取信息 getinfo 因为里面包含updateuser
                                    store.dispatch("getinfo", {
                                        success() {
                                            store.commit("updatePullingInfo", false)
                                        },
                                        error() {
                                            store.commit("updatePullingInfo", false)
                                        },
                                    })
                                    message({
                                        type: 'success',
                                        message: "修改成功",
                                    })
                                } else {
                                    message({
                                        type: 'warning',
                                        message: resp.error_message,
                                    })
                                }
                            },
                        })
                        this.name = this.about = this.photo = ""
                    },
                    error: (error) => {
                        console.error('发生错误:', error);
                    }
                });
            },
            open() {
                this.dialogFormVisible = true
            },
            cancel() {
                this.dialogFormVisible = false
                this.$message({
                    type: 'info',
                    message: '取消修改'
                });      
                this.name = this.about = this.photo = ""
            },
            ul() {
                const message = this.$message

                const name = this.name.trim()
                const about = this.about.trim()
                const photo = this.photo.trim()

                const vue = this
                const store = this.$store

                $.ajax({
                    url:'https://app6132.acapp.acwing.com.cn/api/user/account/update/',
                    type:'post',
                    data: {
                        name:name,
                        about:about,
                        photo:photo,
                    },
                    headers: {
                        Authorization: "Bearer " + store.state.me.token
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            console.log("修改成功了")
                            // 直接获取信息 getinfo 因为里面包含updateuser
                            store.dispatch("getinfo", {
                                success() {
                                    store.commit("updatePullingInfo", false)
                                },
                                error() {
                                    store.commit("updatePullingInfo", false)
                                },
                            })
                            message({
                                type: 'success',
                                message: "修改成功",
                            })
                        } else {
                            message({
                                type: 'warning',
                                message: resp.error_message,
                            })
                        }
                    },
                })
                this.name = this.about = this.photo = ""
            },
            accept() {
                this.dialogFormVisible = false
                

                if (this.fileToUpload !== null) {
                    this.uploadFile()
                } else {
                    this.ul()
                }
            },
        }
    }
</script>

<style scoped>

</style>